import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { UserSettingsQuery } from '@examdojo/user-settings';
import { distinctUntilChanged, EMPTY, filter, merge, switchMap } from 'rxjs';
import { UserMarksService } from '../user/mark/user-marks.service';

@Injectable()
export class FetchUserMarksOnTimezoneChangeEffectService {
  constructor(
    private readonly userMarksService: UserMarksService,
    private readonly userSettingsQuery: UserSettingsQuery,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {
    this.userSettingsQuery.timezone$
      .pipe(
        filter(Boolean),
        distinctUntilChanged(),
        switchMap(() =>
          merge(
            this.userMarksService
              .fetchLastWeekUserMarks()
              .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY)),
            this.userMarksService
              .getUserSpentPointsAndLimits()
              .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY)),
          ),
        ),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
